import Toggle from 'accessible-toggle';
import reframe from 'reframe.js/dist/reframe.es';
import 'van11y-accessible-tab-panel-aria';
import './modules/carousel';
import './modules/gdpr';
import './modules/peopleSearch';
import './modules/rotate';
import './modules/scrollAnimation';
import './modules/slideshow';
import './plugins/externalLinks';
import './plugins/inplace';
import './plugins/isScrolled';

// Make sure videos keep their aspect ratio
reframe('iframe:not(.no-reframe)');

// Toggle navigation using hamburger menu
new Toggle(document.getElementById('navigation-header'), {
    mediaQuery: '(max-width: 46.875em)',
    closeOnClickOutside: true,
});
